<!-- text-formatting-input.component.html -->
<div class="NgxEditor__Wrapper input" [ngClass]="inputHeight">
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
  <ngx-editor 
    [editor]="editor"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [placeholder]="'Type here...'"
    [disabled]="isDisabled">
  </ngx-editor>
</div>
